import {
  DatePicker,
  LocalizationProvider,
  DatePickerProps,
} from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
//import { TextField, TextFieldProps } from '@mui/material'

import { dateFormat } from '@/constants/date'

interface Props extends DatePickerProps<Date> {}

export const DatePickerCustomComponent = ({
  slots,
  slotProps,
  ...props
}: Props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        format={dateFormat}
        /*  slots={{
          textField: (params: TextFieldProps) => <TextField {...params} />,
          ...slots,
        }} */
        slotProps={{
          ...slotProps,
          textField: {
            margin: 'normal',
            sx: { marginTop: '8px' },
            ...(slotProps?.textField || {}),
          },
          popper: {
            popperOptions: {
              modifiers: [
                {
                  name: 'applyCustom',
                  enabled: true,
                  phase: 'beforeWrite',
                  requires: ['computeStyles'],
                  fn: ({ state }: { state: Partial<any> }) => {
                    state.styles.popper.height = '358px'
                    if (state.placement.includes('top-start')) {
                      state.styles.popper = {
                        ...state.styles.popper,
                        display: 'flex',
                        alignItems: 'flex-end',
                      }
                    }
                    if (state.placement.includes('bottom')) {
                      state.styles.popper = {
                        ...state.styles.popper,
                        display: 'block',
                      }
                    }
                  },
                },
              ],
            },
            ...(slotProps?.popper || {}),
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  )
}
